import { useState, useCallback } from "react";

export const useKeywords = () => {
  const [keywords, setKeywords] = useState({});

  const initKeywords = useCallback((data) => {
    setKeywords((prev) => ({ ...prev, ...data }));
  }, []);

  const setForFile = useCallback((fileId, fileKeywords) => {
    setKeywords((prev) => ({ ...prev, [fileId]: fileKeywords }));
  }, []);

  const add = useCallback((fileId, keyword) => {
    const trimmed = keyword.trim();
    if (!trimmed) return false;

    const current = keywords[fileId] || [];
    if (current.includes(trimmed)) return false;

    setKeywords((prev) => ({
      ...prev,
      [fileId]: [...(prev[fileId] || []), trimmed],
    }));
    return true;
  }, [keywords]);

  const remove = useCallback((fileId, keyword) => {
    setKeywords((prev) => ({
      ...prev,
      [fileId]: (prev[fileId] || []).filter((k) => k !== keyword),
    }));
  }, []);

  const get = useCallback((fileId) => {
    return keywords[fileId] || [];
  }, [keywords]);

  const clear = useCallback((fileId) => {
    setKeywords((prev) => {
      const { [fileId]: _, ...rest } = prev;
      return rest;
    });
  }, []);

  return {
    keywords,
    initKeywords,
    setForFile,
    add,
    remove,
    get,
    clear,
  };
};